/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RepairExtension
 */
export interface RepairExtension {
    /**
     * 
     * @type {number}
     * @memberof RepairExtension
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairExtension
     */
    'status'?: RepairExtensionStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof RepairExtension
     */
    'date'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairExtension
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairExtension
     */
    'damageAssessorComment'?: string;
}

export const RepairExtensionStatusEnum = {
    Requested: 'requested',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type RepairExtensionStatusEnum = typeof RepairExtensionStatusEnum[keyof typeof RepairExtensionStatusEnum];


